"use client";
import { useScrollLock } from "@repo/lib/hooks/common";
import { IconCross } from "@repo/assets/images";
import cx from "classnames";
import { useMemo } from "react";

const BottomSheet = ({
  children,
  isOpen,
  onClose,
  title,
  actions,
  variant = "auto",
  className,
  classes = {},
}) => {
  // Bottom sheet height Full
  const variantFullClasses = useMemo(
    () =>
      variant === "full" &&
      cx(
        "bottom-sheet-full h-full fixed bottom-0 left-0 z-70 w-full bg-white shadow-md transition-all duration-300 ease-in-out"
      ),
    [variant]
  );

  // Bottom sheet height auto
  const variantAutoClasses = useMemo(
    () =>
      variant === "auto" &&
      cx(
        "bottom-sheet-auto h-auto fixed bottom-0 left-0 z-70 w-full bg-white p-4 shadow-md transition-all duration-300 ease-in-out"
      ),
    [variant]
  );

  useScrollLock({ lock: isOpen });

  return (
    <>
      {isOpen && (
        <button
          type="button"
          className="z-60 fixed inset-0 w-full cursor-default rounded-none border-none bg-[#0000004D] text-[0px] transition-all delay-300 duration-300"
          name="closeBottomSheetOutside"
          onClick={onClose}
        >
          Close
        </button>
      )}
      <div
        className={cx(
          isOpen ? "translate-y-0" : "translate-y-full",
          variantAutoClasses,
          variantFullClasses,
          classes.root,

          className
        )}
      >
        <div
          className={cx(
            variant === "full"
              ? "bg-bg-medium-gray px-4 py-4"
              : "flex items-center"
          )}
        >
          {title && (
            <div
              className={cx(
                "font-heading text-supportiveBlack rtl:font-arabic text-lg font-medium",
                classes.title
              )}
            >
              {title}
            </div>
          )}
          {!variantFullClasses && (
            <button
              onClick={onClose}
              className="ms-auto"
              name={`close ${title || "bottomsheet"}`}
              aria-label={`close ${title || "bottomsheet"}`}
            >
              <IconCross className="text-icon-color w-4 cursor-pointer fill-current font-bold" />
            </button>
          )}
        </div>
        <div
          className={cx({
            "mb-4": !actions,
          })}
        >
          {children}
        </div>
      </div>
    </>
  );
};

export default BottomSheet;
